import React, { useState, useContext, useEffect } from 'react';
import InputBox from '../../atomic/inputbox/InputBox';
import AtomicButton from '../../atomic/button/Button';
import { useNavigate } from 'react-router-dom';

import { isPassword, isValidEmail, emailRegex } from '../../utils/regexValidation';
import { Alert } from '@mui/material';
import { SignUpDataContext } from '../../context-api/data-provider/SignupDataProvider';
import responseErrorMapping from '../../utils/error.response.mapping';
import { Error404 } from '../../composed/error404/Error404';

const ForgotPasswordPage = () => {
  const { forgotPasswordData, onForgotPassword } = useContext(SignUpDataContext);
  const navigate = useNavigate();
  const [email, setEmail] = useState(undefined);
  const [isEmailFormatValid, setEmailFormatValid] = useState(true);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const RedirectToLogin = () => navigate('/login');
  const RedirectToSignup = () => navigate('/checkzipcode');
  const { loading, data, success, message } = forgotPasswordData;
  const TryCatchError =
    success === false &&
    message?.CustomMessage === 'Something is seriouly wrong,This is last CATCH block';
  const NotificationSeverIsUp = data?.data?.notificationEmailResponse?.success;

  const onChangeHandler = (event) => {
    setShowSuccessAlert(false);
    setEmail(event.target.value);
  };

  const onSubmitHandler = async () => {
    const isEmailValid = isValidEmail(email);
    setEmailFormatValid(isEmailValid);
    if (isEmailValid) {
      const Resp = await onForgotPassword({ email });
      if (Resp?.forgotAPIResponse?.data?.CustomMessage === 'Forgot password Email sent') {
        setShowSuccessAlert(true);
      }
    }
  };

  const showError =
    !isEmailFormatValid ||
    (success === false && message === 'There is no user with that email') ||
    TryCatchError;

  if (success === false && message === 'Network Error') {
    return <Error404 />;
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        // alignItems: 'center',
        minHeight: '80vh',
        width: 'auto',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          marginTop: '50px',
          width: '420px',
        }}
      >
        <div
          style={{
            display: 'flex',
            textAlign: 'left',
            paddingBottom: '10px',
            fontSize: '32px',
            fontFamily: 'Inter Medium',
            color: 'rgb(63, 63, 110)',
          }}
        >
          Forgot password
        </div>
        <div
          style={{
            fontFamily: 'Inter Regular',
            fontSize: '14px',
            color: 'rgb(63, 63, 110)',
            marginBottom: '15px',
          }}
        >
          Enter the email address associated with your account, and we'll email you a link to reset
          the password.{' '}
        </div>

        {showError && (
          <Alert severity='error' sx={{ border: 'solid 1px red', margin: '10px 0px 10px 0px' }}>
            {!isEmailFormatValid ? (
              'Invalid Email'
            ) : (
              <div>
                {TryCatchError && responseErrorMapping(message?.CustomMessage)}

                {!TryCatchError && responseErrorMapping(message)}
              </div>
            )}
          </Alert>
        )}

        {NotificationSeverIsUp === false && (
          <Alert severity='error' sx={{ border: 'solid 1px red', margin: '10px 0px 10px 0px' }}>
            <div>Email server is down please try later</div>
          </Alert>
        )}
        {showSuccessAlert && NotificationSeverIsUp !== false && (
          <Alert
            severity='success'
            sx={{
              border: '2px solid #33AE1C',
              color: '#33AE1C',
              margin: '10px 0px 10px 0px',
              backgroundColor: 'transparent',
            }}
          >
            <div style={{ fontFamily: 'Inter Regular', color: 'green' }}>
              If your email address exists in our database,you will receive a password recovery link
              at your email address in a few minutes
            </div>
          </Alert>
        )}

        <InputBox
          type='email'
          label='Email'
          size='small'
          sx={{ width: '100%', height: 'auto', margin: '6px 0px 5px 0px' }}
          name='email'
          value={email}
          inputErrorMsg=''
          error={!isEmailFormatValid}
          onChange={onChangeHandler}
        />

        <AtomicButton
          loading={false}
          handleSubmit={onSubmitHandler}
          label='SEND RESET INSTRUCTIONS'
          endIcon={false}
          startIcon={false}
          loadingIcon
          loadingButtonStyle={{}}
          style={{
            backgroundColor: '#181436',
            width: '100%',
            marginTop: '15px',
            marginBottom: '15px',
          }}
        />

        <div style={{ justifyContent: 'center' }}>
          <span
            onClick={RedirectToLogin}
            style={{
              cursor: 'pointer',
              fontFamily: 'Inter Regular',
              fontSize: '16px',
              color: '#5078e6',
            }}
          >
            Back to log in&nbsp;|
          </span>
          <span
            onClick={RedirectToSignup}
            style={{
              cursor: 'pointer',
              fontFamily: 'Inter Regular',
              fontSize: '16px',
              color: '#5078e6',
            }}
          >
            &nbsp; Sign up
          </span>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
